<script setup lang="ts">
  import { Image } from "@src/components";
  import { default as ProductZoneWithoutImage } from "./ProductZoneWithoutImage.vue";

  const { zones, img, article, isBlocked } = defineProps<{
    zones: Array<{
      id: string;
      path: string;
      location: string;
    }>;
    img?: string;
    article?: string;
    isBlocked?: boolean;
  }>();
</script>

<template>
  <div class="product-zone">
    <Image :url="img" class="product-zone__image" />
    <ProductZoneWithoutImage :article="article" :zones="zones" :isBlocked="isBlocked" />
  </div>
</template>

<style scoped>
  .product-zone {
    display: flex;
    gap: 12px;
    padding: 12px;
    border-radius: 12px;
    background-color: var(--sf-base-background-white);
  }

  .product-zone__image {
    width: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
